import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCitas } from "../../services/citas";
import { getMedicoAuth } from "../../services/usuarios";
import { sincronizarNotificacionPago } from "../../services/notificaciones";
import WeekView from "../Modulos/Agendamiento/ComponentsAgendamiento/ComponentsCalendarView/WeekView";
import "./DashboardContent.css";
import ModalCita from "../Modulos/Agendamiento/ComponentsAgendamiento/ComponentsCalendarView/ModalCita";
import { getHistoriaClinicaPorPaciente } from "../../services/historiaClinica";
import { getResumenInicio } from "../../services/finanzas";


const DashboardContent = () => {
  const [refresh, setRefresh] = useState(false);
  
  const [citasHoy, setCitasHoy] = useState([]); // ✅ Nuevo estado para citas del día
  const [resumenInicio, setResumenInicio] = useState({
  citas_hoy: 0,
  citas_mes: 0,
  pacientes_registrados_mes: 0,
  consultas_mes: 0,
});
  
  const [doctorNombre, setDoctorNombre] = useState("Doctor");
  const [doctorSaludo, setDoctorSaludo] = useState("Bienvenido");
  const navigate = useNavigate();
  const [mostrarModal, setMostrarModal] = useState(false);
  const [citaSeleccionada, setCitaSeleccionada] = useState(null);
  const [horario, setHorario] = useState({});


  useEffect(() => {
    const fetchData = async () => {
      try {
        const citasData = await getCitas();
      
        const resumenInicioData = await getResumenInicio();
        

        // 📌 Filtrar citas del día correctamente
        const hoy = new Date();
        const fechaHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}-${String(hoy.getDate()).padStart(2, "0")}`;
        let citasFiltradas = citasData.filter(cita => cita.fecha === fechaHoy);

        // 📌 Ordenar citas del día por hora
        citasFiltradas.sort((a, b) => {
          if (!a.start_time) return 1;
          if (!b.start_time) return -1;
          return a.start_time.localeCompare(b.start_time);
        });

        // ✅ Guardamos correctamente las citas en los estados correspondientes
        
        setCitasHoy(citasFiltradas); // Ahora se usa este estado
       
        setResumenInicio(resumenInicioData);

          const medico = await getMedicoAuth();// ✅ Generamos el saludo personalizado del doctor
         
         const esDoctora = medico?.sexo === "Femenino" || medico?.sexo === "Mujer";
          const titulo = esDoctora ? "Dra." : "Dr.";
          const saludo = esDoctora ? "Bienvenida" : "Bienvenido";
          const nombreCompleto = `${titulo} ${medico.nombre || ""} ${medico.apellido_paterno || ""} `;
          
          setDoctorSaludo(saludo);
          setDoctorNombre(nombreCompleto);
          setHorario(medico?.perfil?.horario ?? {});
        
      } catch (error) {
        console.error("Error obteniendo datos:", error);
      }
    };

    fetchData();
  }, [refresh]);

   // Sincroniza notificaciones de pago (una vez al montar el dashboard)
  useEffect(() => {
    sincronizarNotificacionPago().catch(() => {});
  }, []);

  const handleAgregarPaciente = () => {
    navigate("/dashboard/alta-paciente");
  };

  const abrirModalNuevaCita = () => {
    const hoy = new Date().toISOString().split("T")[0]; // 📅 Formato YYYY-MM-DD
    setCitaSeleccionada({
        fecha: hoy,
        start_time: "",
        end_time: "",
        motivo: "",
        paciente: "",
    });
    setMostrarModal(true);
  };

  const handleGenerarReceta = () => {
    navigate("/dashboard/recetas/formulario", { state: { receta: null } });
  };
  const abrirModalEditarCita = (cita) => {
    setCitaSeleccionada(cita);  // 🔹 Guardamos la cita a editar
    setMostrarModal(true);       // 🔹 Mostramos el modal
  };
  
  //boton de inicio de consulta

  const handleIniciarConsulta = async (pacienteId) => {
  try {
    const historiaClinica = await getHistoriaClinicaPorPaciente(pacienteId);

    if (!historiaClinica || !historiaClinica.id) {
      navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
      return;
    }

    if (historiaClinica.fecha_consulta) {
      navigate(`/dashboard/consulta-seguimiento/${pacienteId}`);
    } else {
      navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
    }
  } catch (error) {
    console.error("Error al obtener historia clínica:", error);
    if (error.response && error.response.status === 404) {
      navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
    } else {
      alert("No se pudo obtener la historia clínica. Intenta de nuevo.");
    }
  }
  };


  return (
    <div className="dashboard-content2">
      {/* Mensaje de Bienvenida */}
      <div className="welcome-message">
        <h2>¡{doctorSaludo}, {doctorNombre}!</h2>
      </div>

      {/* Widget de Próximas Citas */}
      <div className="appointments-widget">
        <h3>Próximas Citas</h3>
        <div className="appointments-list">
          {citasHoy.filter((cita) => {
            const [citaHour, citaMin] = cita.start_time.split(":").map(Number);
            const now = new Date();
            const nowHour = now.getHours();
            const nowMin = now.getMinutes();

            return (
                citaHour > nowHour || (citaHour === nowHour && citaMin >= nowMin) // 🔹 Solo citas futuras
            );
            }).length > 0 ? (
            <ul>
                {citasHoy
                    .filter((cita) => {
                        const [citaHour, citaMin] = cita.start_time.split(":").map(Number);
                        const now = new Date();
                        const nowHour = now.getHours();
                        const nowMin = now.getMinutes();

                        return (
                            citaHour > nowHour || (citaHour === nowHour && citaMin >= nowMin) // 🔹 Solo citas futuras
                        );
                    })
                    .map((cita) => (
                        <li key={cita.id} className={`appointment ${cita.status === "cancelada" ? "cancelada" : ""}`}>
                            <div>
                                <strong className="patient-name">{cita.paciente_nombre}</strong> - 
                                <span className="appointment-time">
                                    {cita.start_time} - {cita.end_time}
                                </span>
                                <p className="appointment-details">
                                    {cita.paciente 
                                        ? (cita.citasPrevias > 0 ? "Paciente Recurrente" : "Paciente Nuevo") 
                                        : "Cita Personal"}  
                                    - <span className="status">{cita.status || "Pendiente"}</span>
                                </p>
                                <p className="appointment-details">motivo:{cita.motivo}</p>
                            </div>
                            <div className="actions">
                            {cita.paciente && ( // ✅ Solo muestra el botón si hay paciente asignado
                                <button onClick={() => handleIniciarConsulta(cita.paciente)}>Iniciar Consulta </button>)}
                                <button onClick={() => abrirModalEditarCita(cita)}>Editar Cita</button>
                            </div>
                        </li>
                    ))}
            </ul>
            ) : (
            <p className="no-appointments">No hay próximas citas</p>
          )}
        </div>
      </div>



      {/* Accesos Rápidos */}
      <div className="quick-access">
        <h3 className="quick-access-title">Accesos Rápidos</h3>
        <button onClick={handleAgregarPaciente}>Agregar Paciente</button>
        <button onClick={abrirModalNuevaCita}>Nueva Cita</button>
        <button onClick={() => navigate("/dashboard/historias-clinicas")}>Iniciar Consulta</button>
        <button onClick={handleGenerarReceta}>Generar Receta</button>
        <button onClick={() => navigate("/dashboard/configuracion/perfil")}> Información del Médico</button>
        <button onClick={() => navigate("/dashboard/configuracion/receta")}> Formato de Receta</button>
        
      </div>

      {/* Datos Clave */}
    <div className="key-metrics">
      
      <button
        className="btn-ver-indicadores"
        onClick={() => navigate("/dashboard/finanzas")}
      >
        Ver todos los indicadores
      </button>
      <div className="kpi-card">
        <p>Citas hoy</p>
        <h3>{resumenInicio.citas_hoy}</h3>
      </div>

      <div className="kpi-card">
        <p>Citas del mes</p>
        <h3>{resumenInicio.citas_mes}</h3>
      </div>

      <div className="kpi-card">
        <p>Pacientes registrados</p>
        <h3>{resumenInicio.pacientes_registrados_mes}</h3>
      </div>

      <div className="kpi-card">
        <p>Consultas del mes</p>
        <h3>{resumenInicio.consultas_mes}</h3>
      </div>

    </div>

      {/* Vista Semanal de Citas */}
      <div className="week-view-container2">
        <h3>Vista Semanal de Citas</h3>
        <WeekView selectedDate={new Date()} refresh={refresh} setRefresh={setRefresh} horario={horario}/>
      </div>
    
    
      {mostrarModal && (
    <ModalCita
        cita={citaSeleccionada}
        onGuardar={() => { 
            setMostrarModal(false); 
            setRefresh((prev) => !prev); 
        }}
        onEliminar={() => { 
            setMostrarModal(false); 
            setRefresh((prev) => !prev);
        }}
        onCerrar={() => setMostrarModal(false)}
    />)}
    </div>
  );
};

export default DashboardContent;
